import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateCollarDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateCollar(
  collarId: string,
  data: UpdateCollarDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.devices.collars.update(collarId),
    data,
  );
  return response.data;
}
